<div class="container-fluid mt-3">
  <h2 class="text-center mb-3">{{ currentEditId ? 'Update Management MOM Session' : 'Add Management MOM Session' }}</h2>

  <form [formGroup]="momForm" class="row mom-scroll-body" autocomplete="off" >
    <!-- Session Date -->

      <mat-form-field appearance="outline" class="col-md-4 mb-3">
        <mat-label>Date</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="date" placeholder="Select date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="momForm.get('date')?.hasError('required')">
          Date is required
        </mat-error>
      </mat-form-field>


    <!-- Participants Field with Multi-Select -->
<!--    <div class="col-md-8 d-flex align-items-start gap-2">-->
<!--      <mat-form-field appearance="outline" class="flex-grow-1">-->
<!--        <mat-label>Select Participants</mat-label>-->
<!--        <mat-select-->
<!--          multiple-->
<!--          formControlName="participants"-->
<!--          aria-label="Select Participants"-->
<!--          #participantSelect="matSelect">-->

<!--          &lt;!&ndash; Trigger display &ndash;&gt;-->
<!--          <mat-select-trigger>-->
<!--            <span *ngIf="participantSelect.value?.length; else noParticipantSelection">-->
<!--              {{ participantSelect.value[0] | slice:0:25 }}-->
<!--              {{ participantSelect.value[0]?.length > 25 ? '...' : '' }}-->
<!--              <span *ngIf="participantSelect.value.length > 1" class="textcol">-->
<!--                (+{{ participantSelect.value.length - 1 }} more)-->
<!--              </span>-->
<!--            </span>-->
<!--            <ng-template #noParticipantSelection>-->
<!--              Select Participants...-->
<!--            </ng-template>-->
<!--          </mat-select-trigger>-->

<!--          &lt;!&ndash; Search box &ndash;&gt;-->
<!--          <div class="mat-select-search" style="padding: 8px;">-->
<!--            <input-->
<!--              type="text"-->
<!--              placeholder="Search participant..."-->
<!--              [value]="participantSearch"-->
<!--              (input)="onParticipantSearchChange($event)"-->
<!--              (click)="$event.stopPropagation()"-->
<!--              (keydown)="$event.stopPropagation()"-->
<!--              class="employee-search-input w-100 p-0 border rounded"-->
<!--              autocomplete="off"-->
<!--            />-->
<!--          </div>-->

<!--          &lt;!&ndash; Participant options &ndash;&gt;-->
<!--          <mat-option *ngFor="let member of filteredManagementMembers" [value]="member">-->
<!--            {{ member }}-->
<!--          </mat-option>-->
<!--        </mat-select>-->
<!--        <mat-error *ngIf="momForm.get('participants')?.hasError('required')">-->
<!--          Participants are required-->
<!--        </mat-error>-->
<!--      </mat-form-field>-->

<!--      &lt;!&ndash; Add Participants Button &ndash;&gt;-->
<!--      <button-->
<!--        mat-mini-fab-->
<!--        color="accent"-->
<!--        type="button"-->
<!--        (click)="openParticipantsDialog()"-->
<!--        matTooltip="Add participants from all employees"-->
<!--        matTooltipPosition="above"-->
<!--        style="margin-top: 8px;">-->
<!--        <mat-icon>group_add</mat-icon>-->
<!--      </button>-->
<!--    </div>-->

    <app-searchable-select
      class="col-md-8 col-sm-8"
      [multiple]="true"
      [options]="filteredManagementMembers"
      [selectedValue]="momForm.get('participants')?.value"
      [displayWithFn]="displayParticipants"
      [placeholder]="'Select Participants'"
      [label]="'Select Participants'"
      (selectionChange)="onParticipantsChange($event)">
    </app-searchable-select>


    <!-- Session Items Table Section -->
    <div class="col-12 mt-3">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h4>Action Items</h4>
        <button type="button" mat-raised-button color="accent" (click)="addSessionRow()">
          <mat-icon>add</mat-icon>
          Add
        </button>
      </div>

      <div class="table-container mat-elevation-z2">
        <table mat-table [dataSource]="sessionDataSource" class="w-100">

          <!-- Topic Column -->
          <ng-container matColumnDef="topic">
            <th mat-header-cell *matHeaderCellDef>Topic *</th>
            <td mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
              <mat-form-field appearance="outline" class="w-100">
      <textarea
        matInput
        formControlName="topic"
        placeholder="Enter topic"
        rows="2">
      </textarea>

                <mat-error *ngIf="element.get('topic')?.hasError('required')">
                  Required
                </mat-error>
              </mat-form-field>
            </td>
          </ng-container>



          <!-- Status/Remark Column -->
          <ng-container matColumnDef="remark">
            <th mat-header-cell *matHeaderCellDef>Status *</th>
            <td mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
              <mat-form-field appearance="outline" class="w-100">
                <mat-select formControlName="remark">
                  <mat-option *ngFor="let status of statusOptions" [value]="status">
                    {{ status }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="element.get('remark')?.hasError('required')">
                  Required
                </mat-error>
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let element; let i = index">
              <button type="button" mat-icon-button color="warn"
                      (click)="removeSessionRow(i)" matTooltip="Remove">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <!-- No Data Row -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center py-3" [attr.colspan]="displayedColumns.length">
              <p class="text-muted">No action items added. Click "Add Action Item" to begin.</p>
            </td>
          </tr>
        </table>
      </div>
    </div>
<div class="row">
  <mat-form-field appearance="outline" class="col-md-12 col-sm-12" *ngIf="isAdmin">
    <mat-label>Remark</mat-label>
    <textarea matInput formControlName="remark" ></textarea>

  </mat-form-field>

</div>
    <!-- Action Buttons -->
    <div class="col-12 d-flex justify-content-end gap-2 mt-4">
      <button
        type="button"
        mat-raised-button
        (click)="cancel()"
        [disabled]="isLoading">
        Cancel
      </button>
      <button
        type="button"
        mat-raised-button
        color="primary"
        (click)="submitForm()"
        [disabled]="momForm.invalid || isLoading">
        <span *ngIf="!isLoading">{{ currentEditId ? 'Update' : 'Save' }}</span>
        <span *ngIf="isLoading">Processing...</span>
      </button>
    </div>
  </form>
</div>

